import SessionType from "../../enums/SessionType.js";

const gameOnlySessionType = function(sessionType) {
    return sessionType === SessionType.Game.key;
};

export default gameOnlySessionType;